import React, { Component } from 'react';
import LandingPage from './LandingPage/LandingPage';

class App extends Component {
  constructor() {
    super();
    this.state = {
      name: 'React'
    };
  }

  render() {
    return (
      <div>
        <LandingPage />
      </div>
    );
  }
}


export default App;
